<div class="flex align-items-center justify-content-center mb-8">
  <div style=" width: 220px">
    <img width="100%" alt="Logo" src="assets/images/Logo_High_Res.jpg" />
  </div>
</div>

<h1>
  <!-- Deal Title -->
  @if (deal?.type == 5) { <!-- Overdue -->
  {{ 'overdue.title' | translate }}
  } @else {
  {{deal?.title}}
  }

  @if (wizardStep() == "PAYMENT_DATA" && elementsOptions.clientSecret) {
  - € {{ actualDueAmount | currency : 'EUR' : '' : '1.2-2' }}
  }
</h1>

<div class="flex flex-column gap-4">
  @if (wizardStep() == "ALREADY_PAID") {
  <p-table [value]="deal?.payments ?? []" styleClass="p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th>#</th>
        <th>{{ 'review.columns.datePaid' | translate }}</th>
        <th>{{ 'review.columns.paymentMethod' | translate }}</th>
        <th>{{ 'review.columns.amount' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-payment>
      <tr>
        <td>{{ payment.index }}</td>
        <td>
          @if (payment.isProcessing) {
          <b>{{ 'review.columns.processing' | translate }}</b>
          } @else {
          {{ payment.datePaid | date }}
          }
        </td>
        <td>{{ payment.paymentMethod == 0 ? 'Bank Account' : 'Card' }}</td>
        <td>{{ payment.amount| currency : 'EUR' : '' : '1.2-2' }}</td>
      </tr>
    </ng-template>
  </p-table>
  }

  @if (wizardStep() == "SUBSCRIPTION_PREVIEW") {

  <div class="flex flex-column gap-2">

    @if (deal?.type == 5) { <!-- Overdue -->
    <p-table [value]="deal?.lines ?? []" styleClass="p-datatable-striped special-font">
      <ng-template pTemplate="footer" let-product>
        <tr>
          <td colspan="4">
            <div class="flex flex-column">
              <span>
                {{ 'customer.vat.label' | translate }}: {{ deal?.customer?.vatNumber }}
              </span>
              <span>
                {{ 'payment.installment' | translate }}: {{ deal?.currentInstalment }}/{{
                deal?.instalments
                }}
              </span>
              <span>
                {{ 'payment.currentDueAmount' | translate }}:
                {{ currentDueAmount | currency : 'EUR' }}
              </span>
              <!--<span>{{ 'payment.vatType' | translate }}: {{ deal?.customer?.taxPolicy! | fpa }}</span>-->
              <!--<span>
                {{ 'payment.netAmount' | translate }}: {{
                deal?.netValue| currency : 'EUR' : 'symbol'
                : '1.2-2'
                }}
              </span>-->
              <span>
                {{ 'payment.grossAmount' | translate }}: {{
                deal?.value| currency : 'EUR' : 'symbol' :
                '1.2-2'
                }}
              </span>
            </div>
          </td>
          <!--<td colspan="2">
            <div class="flex flex-column text-right">
              <span>
                {{ 'payment.netAmount' | translate }}: {{
                deal?.netValue| currency : 'EUR' : 'symbol'
                : '1.2-2'
                }}
              </span>
              <span>
                {{ 'payment.grossAmount' | translate }}: {{
                deal?.value| currency : 'EUR' : 'symbol' :
                '1.2-2'
                }}
              </span>
            </div>
          </td>-->
        </tr>
      </ng-template>
    </p-table>
    } @else {
    <p-table [value]="deal?.lines ?? []" styleClass="p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'payment.columns.product' | translate }}</th>
          <th>{{ 'payment.columns.price' | translate }}</th>
          <th>{{ 'payment.columns.quantity' | translate }}</th>
          <th>{{ 'payment.columns.discount' | translate }}</th>
          <th>{{ 'payment.columns.tax' | translate }}</th>
          <th>{{ 'payment.columns.amount' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product>
        <tr>
          <td>{{ product.productName }}</td>
          <td>{{ product.itemPrice| currency : 'EUR' : '' : '1.2-2' }}</td>
          <td>{{ product.quantity| currency : 'EUR' : '' : '1.2-2' }}</td>
          <td>
            {{ product.discount| currency : 'EUR' : '' : '1.2-2' }} <span *ngIf="product.discountPercentage > 0">
              ({{
              product.discountPercentage
              }}%)
            </span>
          </td>
          <td>{{ product.vat| currency : 'EUR' : '' : '1.2-2' }}</td>
          <td>{{ product.netPrice | currency : 'EUR' : '' : '1.2-2' }}</td>
        </tr>
      </ng-template>
      @if (deal?.value ?? 0 > 0) {
      <ng-template pTemplate="footer" let-product>
        <tr>
          <td colspan="4">
            <div class="flex flex-column">
              <span>
                {{ 'payment.installment' | translate }}: {{ deal?.currentInstalment }}/{{
                deal?.instalments
                }}
              </span>
              <span>
                {{ 'payment.currentDueAmount' | translate }}:
                {{ currentDueAmount | currency : 'EUR' }}
              </span>
              <span>{{ 'payment.vatType' | translate }}: {{ deal?.customer?.taxPolicy! | fpa }}</span>
            </div>
          </td>
          <td colspan="2">
            <div class="flex flex-column text-right">
              <span>
                {{ 'payment.netAmount' | translate }}: {{
                deal?.netValue| currency : 'EUR' : 'symbol'
                : '1.2-2'
                }}
              </span>
              <span>
                {{ 'payment.grossAmount' | translate }}: {{
                deal?.value| currency : 'EUR' : 'symbol' :
                '1.2-2'
                }}
              </span>
            </div>
          </td>
        </tr>
      </ng-template>
      }
    </p-table>

    <div *ngIf="hasWebSiteBuilder" class="my-4 px-2">
      {{ 'notes.websiteBuilder' | translate }} <a href="https://www.hotelwize.com/eula/" target="_blank">
        {{
        'notes.link'
        | translate
        }}
      </a>.
    </div>
    }
    <div>
      <p-toolbar>
        <div class="p-toolbar-group-start">
        </div>
        <div class="p-toolbar-group-center">
        </div>
        <div class="p-toolbar-group-end">
          <p-button (click)="proceedToCustomerData()" [label]="translateService.instant('buttons.procceed')"
            icon="pi pi-arrow-right" iconPos="right"></p-button>
        </div>
      </p-toolbar>
    </div>
  </div>
  }

  <div [formGroup]="paymentElementForm">
    @if (wizardStep() == "CUSTOMER_DATA" || wizardStep() == "SUBMITING_CUSTOMER_DATA") {

    <div class="flex flex-column gap-2">

      <h2>{{ 'headers.taxData' | translate }}</h2>

      <div class="flex flex-column md:flex-row gap-2 w-full">
        <div class="flex flex-column gap-2 w-full">
          <label for="legalName">{{ 'customer.legalName.label' | translate }}</label>
          <input id="legalName" matInput pInputText formControlName="legalName"
            [ngClass]="legalName?.invalid && (paymentElementFormTriedToSubmit|| legalName?.dirty || legalName?.touched) ? 'ng-dirty ng-invalid' : ''" />
        </div>

        <div class="flex flex-column gap-2 w-full">
          <label for="vat">{{ 'customer.vat.label' | translate }}</label>
          <input id="vat" matInput pInputText formControlName="vat"
            [ngClass]="vat?.invalid && (paymentElementFormTriedToSubmit || vat?.dirty || vat?.touched) ? 'ng-dirty ng-invalid' : ''" />
        </div>
      </div>

      <div class="flex flex-column md:flex-row gap-2 w-full">
        <div class="flex flex-column gap-2 w-full">
          <label for="name">{{ 'customer.name.label' | translate }}</label>
          <input id="name" matInput pInputText formControlName="name"
            [ngClass]="name?.invalid && (paymentElementFormTriedToSubmit || name?.dirty || name?.touched) ? 'ng-dirty ng-invalid' : ''" />
        </div>

        <div class="flex flex-column gap-2 w-full">
          <label for="phone">{{ 'customer.phone.label' | translate }}</label>
          <input id="phone" matInput pInputText formControlName="phone"
            [ngClass]="phone?.invalid && (paymentElementFormTriedToSubmit || phone?.dirty || phone?.touched) ? 'ng-dirty ng-invalid' : ''" />
        </div>
      </div>

      <div class="flex flex-column md:flex-row gap-2 w-full">
        <div class="flex flex-column gap-2 w-full">
          <label for="offemail">{{ 'customer.offEmail.label' | translate }}</label>
          <input id="offemail" matInput pInputText type="email" formControlName="officialEmail"
            [ngClass]="officialEmail?.invalid && (paymentElementFormTriedToSubmit || officialEmail?.dirty || officialEmail?.touched) ? 'ng-dirty ng-invalid' : ''" />
        </div>

        <div class="flex flex-column gap-2 w-full">
          <label for="email">{{ 'customer.email.label' | translate }}</label>
          <input id="email" matInput pInputText type="email" formControlName="email"
            [ngClass]="email?.invalid && (paymentElementFormTriedToSubmit || email?.dirty || email?.touched) ? 'ng-dirty ng-invalid' : ''" />
          <small id="email-help">{{ 'customer.email.description' | translate }}</small>
        </div>
      </div>

      <div class="flex flex-column md:flex-row gap-2 w-full">
        <div class="flex flex-column gap-2 w-full">
          <label for="country">{{ 'customer.address.country.label' | translate }}</label>
          <p-dropdown id="country" formControlName="country" [options]="countries" optionLabel="name" optionValue="code"
            [virtualScroll]="true" [virtualScrollItemSize]="40"
            [ngClass]="country?.invalid && (paymentElementFormTriedToSubmit || country?.dirty || country?.touched) ? 'ng-dirty ng-invalid' : ''"
            [showClear]="true" [filter]="true" [style]="{ width: '100%'}"></p-dropdown>
        </div>

        <div class="flex flex-column gap-2 w-full">
          <label for="city">{{ 'customer.address.city.label' | translate }}</label>
          <input id="city" matInput pInputText formControlName="city"
            [ngClass]="city?.invalid && (paymentElementFormTriedToSubmit || city?.dirty || city?.touched) ? 'ng-dirty ng-invalid' : ''" />
        </div>
      </div>

      <div class="grid">
        <div class="col-12 md:col-6 flex flex-column gap-2">
          <label for="address">{{ 'customer.address.street.label' | translate }}</label>
          <input id="address" matInput pInputText formControlName="address"
            [ngClass]="address?.invalid && (paymentElementFormTriedToSubmit || address?.dirty || address?.touched) ? 'ng-dirty ng-invalid' : ''" />
        </div>

        <div class="col-12 md:col-3 flex flex-column gap-2">
          <label for="streetNumber">{{ 'customer.address.number.label' | translate }}</label>
          <input id="streetNumber" matInput pInputText formControlName="streetNumber"
            [ngClass]="streetNumber?.invalid && (paymentElementFormTriedToSubmit || streetNumber?.dirty || streetNumber?.touched) ? 'ng-dirty ng-invalid' : ''" />
        </div>

        <div class="col-12 md:col-3 flex flex-column gap-2">
          <label for="zipcode">{{ 'customer.address.zip.label' | translate }}</label>
          <input id="zipcode" matInput pInputText formControlName="zipcode"
            [ngClass]="zipcode?.invalid && (paymentElementFormTriedToSubmit || zipcode?.dirty || zipcode?.touched) ? 'ng-dirty ng-invalid' : ''" />
        </div>
      </div>

      <h2>{{ 'headers.marketingData' | translate }}</h2>

      <div class="flex flex-column md:flex-row gap-2 w-full">
        <div class="flex flex-column gap-2 w-full">
          <label for="locality">{{ 'marketing.locality.label' | translate }}</label>
          <p-dropdown id="locality" formControlName="locality" [options]="customerMasterData.localities"
            optionLabel="display" optionValue="key" [showClear]="true" [filter]="true"
            [ngClass]="locality?.invalid && (paymentElementFormTriedToSubmit || locality?.dirty || locality?.touched) ? 'ng-dirty ng-invalid' : ''"
            [virtualScroll]="true" [virtualScrollItemSize]="38" [style]="{ width: '100%'}"></p-dropdown>
        </div>

        <div class="flex flex-column gap-2 w-full">
          <label for="operatingPeriod">{{ 'marketing.operatingPeriod.label' | translate }}</label>
          <p-dropdown id="operatingPeriod" formControlName="operatingPeriod"
            [options]="customerMasterData.operatingPeriods" optionLabel="display" optionValue="key"
            [ngClass]="operatingPeriod?.invalid && (paymentElementFormTriedToSubmit || operatingPeriod?.dirty || operatingPeriod?.touched) ? 'ng-dirty ng-invalid' : ''"
            [showClear]="true" [filter]="true" [style]="{ width: '100%'}"></p-dropdown>
        </div>
      </div>

      <div class="flex flex-column md:flex-row gap-2 w-full">
        <div class="flex flex-column gap-2 w-full">
          <label for="venueType">{{ 'marketing.venueType.label' | translate }}</label>
          <p-dropdown id="venueType" formControlName="venueType" [options]="customerMasterData.venueTypes"
            optionLabel="display" optionValue="key" [showClear]="true" [filter]="false"
            [ngClass]="venueType?.invalid && (paymentElementFormTriedToSubmit || venueType?.dirty || venueType?.touched) ? 'ng-dirty ng-invalid' : ''"
            [style]="{ width: '100%'}"></p-dropdown>
        </div>

        <div class="flex flex-column gap-2 w-full">
          <label for="venueTier">{{ 'marketing.venueTier.label' | translate }}</label>
          <p-dropdown id="venueTier" formControlName="venueTier" [options]="customerMasterData.venueTiers"
            optionLabel="display" optionValue="key" [showClear]="true" [filter]="false"
            [ngClass]="venueTier?.invalid && (paymentElementFormTriedToSubmit || venueTier?.dirty || venueTier?.touched) ? 'ng-dirty ng-invalid' : ''"
            [style]="{ width: '100%'}"></p-dropdown>
        </div>
      </div>

      @if (deal?.value ?? 0 > 0) {
      <div class="my-4 px-2">
        {{ 'notes.step3Intro' | translate }}
      </div>
      }

      <div class="mb-8">
        <p-toolbar>
          <div class="p-toolbar-group-start">
            <p-button (click)="backToPreview()" [label]="translateService.instant('buttons.back')"
              icon="pi pi-arrow-left" iconPos="left"></p-button>
          </div>
          <div class="p-toolbar-group-center">
          </div>
          <div class="p-toolbar-group-end">
            <p-button (click)="submitCustomerData()" [label]="translateService.instant('buttons.procceed')"
              icon="pi pi-arrow-right" iconPos="right"></p-button>
          </div>
        </p-toolbar>
      </div>
    </div>
    }

    @if (wizardStep() == "PAYMENT_DATA" && elementsOptions.clientSecret) {

    <!--<div class="mb-4 font-italic opacity-80">
    {{ 'payment.iban' | translate }}
  </div>-->

    <div class="mt-2 mb-4">
      <div class="mb-2">{{ 'payment.help.title' | translate }}</div>
      <div [innerHTML]="'payment.help.method1' | translate"></div>
      <div [innerHTML]="'payment.help.method2' | translate"></div>
    </div>

    <div class="mt-2 mb-4 font-italic" [innerHTML]="'payment.help.stripe' | translate"></div>

    <div class="flex flex-column gap-2">
      <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
        <ngx-stripe-payment [stripe]="stripe!" [elementsOptions]="elementsOptions" />
      </ngx-stripe-elements>


      @if (deal?.type == 5) {
      <div class="mb-2 opacity-80 stripe-small-text" [innerHTML]="'overdue.help.recuring' | translate"></div>
      }
      @else
      {
      <div class="mb-2 opacity-80 stripe-small-text" [innerHTML]="'payment.help.recuring' | translate"></div>
      <div class="mb-2 opacity-80 stripe-small-text" [innerHTML]="'payment.help.recuringRenewal' | translate"></div>
      }

      <p-toolbar>
        <div class="p-toolbar-group-start">
          <p-button (click)="backToCustomerData()" [label]="translateService.instant('buttons.back')"
            icon="pi pi-arrow-left" iconPos="left"></p-button>
        </div>
        <div class="p-toolbar-group-center">
        </div>
        <div class="p-toolbar-group-end">
          <p-button (click)="pay()" [label]="translateService.instant('buttons.pay')" icon="pi pi-check"
            iconPos="right"></p-button>
        </div>
      </p-toolbar>
    </div>
    }

    @if (wizardStep() == "COLLECT_CARD_NUMBER" && elementsOptions.clientSecret) {
    <div class="mt-2 mb-4">
      <div class="mb-2" [innerHTML]="'collection.help.title' | translate"></div>
      <!--<div [innerHTML]="'payment.help.method1' | translate"></div>
      <div [innerHTML]="'payment.help.method2' | translate"></div>-->
    </div>

    <div class="mt-2 mb-4 font-italic" [innerHTML]="'payment.help.stripe' | translate"></div>

    <div class="flex flex-column gap-2">
      <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
        <ngx-stripe-payment [stripe]="stripe!" [elementsOptions]="elementsOptions" />
      </ngx-stripe-elements>

      <div class="mb-2 opacity-80 stripe-small-text" [innerHTML]="'collection.help.recuring' | translate"></div>

      <p-toolbar>
        <div class="p-toolbar-group-start">
          <p-button (click)="backToCustomerData()" [label]="translateService.instant('buttons.back')"
            icon="pi pi-arrow-left" iconPos="left"></p-button>
        </div>
        <div class="p-toolbar-group-center">
        </div>
        <div class="p-toolbar-group-end">
          <p-button (click)="collectPaymentData()" [label]="translateService.instant('buttons.collectCard')"
            icon="pi pi-check" iconPos="right"></p-button>
        </div>
      </p-toolbar>
    </div>
    }
  </div>

  @if (wizardStep() == "SUCCESS") {
  <div class="flex flex-column align-items-center">
    <!-- [subheader]="translateService.instant('result.success.message')" -->
    <p-card [header]="translateService.instant('result.success.title')" [style]="{ 'max-width': '520px' }">
      <!--<i class="pi pi-check text-green-500 font-bold" style="font-size: 120px;"></i>-->
      <!--<ng-template pTemplate="header">

      <img alt="Card" src="assets/images/logo-white.png" style="background-color: #b7b7b7;" />
    </ng-template>-->
      <p>

        @if (nextPayment != null && nextPayment.isProcessing == true) {
        <b>{{ 'result.processing' | translate }}</b>
        } @else if (nextPayment != null && nextPayment.done == true) {
        <b>{{ 'result.success.message' | translate }}</b>
        } @else if (nextPayment != null && nextPayment.isProcessing != true) {
        <b>{{ 'result.nextPayment' | translate: { paymentValue: nextPaymentDate } }}</b>
        }
      </p>
      <ng-template pTemplate="footer">
        <div class="flex flex-column align-items-end">
          <p-button [label]="translateService.instant('buttons.close')" icon="pi pi-check" (click)="close()"></p-button>
        </div>
      </ng-template>
    </p-card>
  </div>
  }

  @if (wizardStep() == "COLLECTION_SUCCESS") {
  <div class="flex flex-column align-items-center">
    <div class="mt-2 mb-4">
      <div class="text-2xl">{{ 'collection.successMessage' | translate }}</div>
    </div>
  </div>
  }

</div>

<p-confirmDialog #cd>
  <ng-template pTemplate="headless" let-message>
    <div class="flex flex-column align-items-center p-5 surface-overlay border-round">
      <div
        class="border-circle bg-red-400 text-white inline-flex justify-content-center align-items-center h-6rem w-6rem -mt-8">
        <i class="pi pi-times text-5xl"></i>
      </div>
      <span class="font-bold text-2xl block mb-2 mt-4">{{ message.header }}</span>
      <p class="mb-0">{{ message.message }}</p>
      <div class="flex align-items-center gap-2 mt-4">
        <button pButton [label]="translateService.instant('buttons.close')" (click)="cd.accept()"
          class="w-8rem"></button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>